module.exports = __webpack_public_path__ + "assets/img/15_406_big.1a223ef9.jpg";